import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { Sort as S } from "@planzone/dto";

import { SelectList } from "@common/selectList";
import { ToggleArrowIcon } from "@common/assets/toggleArrowIcon";
import { Props } from "./types";
import styles from "./styles.scss";

const sorts: S[] = [
  "ascendingStartDate",
  "ascendingEndDate",
  "descendingCompletionDate",
  "ascendingName",
  "descendingName",
];

function Sort(props: Props) {
  const { t } = useTranslation();
  const labels = {
    ascendingName: t(
      "exportReportsPage.wbsZonesReport.sorts.ascendingAlphabeticalOrder",
    ),
    descendingName: t(
      "exportReportsPage.wbsZonesReport.sorts.descendingAlphabeticalOrder",
    ),
    ascendingStartDate: t("exportReportsPage.wbsZonesReport.sorts.startDate"),
    ascendingEndDate: t("exportReportsPage.wbsZonesReport.sorts.endDate"),
    descendingCompletionDate: t(
      "exportReportsPage.wbsZonesReport.sorts.completionDate",
    ),
  };

  return (
    <div className={styles.sort}>
      <p className={styles.label}>
        {t("exportReportsPage.wbsZonesReport.sorts.title")}
      </p>
      <div className={styles.form}>
        <SelectList listClassName={styles.listRoot}>
          {({ isOpen, select }) => ({
            input: (
              <div
                className={classNames(styles.input, {
                  [styles.opened]: isOpen,
                })}
              >
                <p className={styles.placeholder}>
                  {props.sort
                    ? labels[props.sort as keyof typeof labels]
                    : t("exportReportsPage.wbsZonesReport.sorts.default")}
                </p>
                <ToggleArrowIcon className={styles.icon} />
              </div>
            ),
            list: (
              <ul className={styles.list}>
                <li
                  className={classNames(styles.item, {
                    [styles.selected]: props.sort === null,
                  })}
                  onClick={() => props.select(null)}
                >
                  <p className={styles.option}>
                    {t("exportReportsPage.wbsZonesReport.sorts.default")}
                  </p>
                </li>
                {sorts.map((sort) => (
                  <li
                    className={classNames(styles.item, {
                      [styles.selected]: props.sort === sort,
                    })}
                    onClick={() =>
                      props.select(sort === props.sort ? null : sort)
                    }
                  >
                    <p className={styles.option}>
                      {labels[sort as keyof typeof labels]}
                    </p>
                  </li>
                ))}
              </ul>
            ),
          })}
        </SelectList>
      </div>
    </div>
  );
}

export { Sort };
